import { BoringContainer } from "./styles";

export function BlindDuelPrivacy() {
  return (
    <BoringContainer>
      <strong>Privacy Policy</strong>
      <p>
        This privacy policy applies to the BlindDuel app (hereby referred to
        as "Application") for mobile devices that was created by Yuriy
        Tolstykh (hereby referred to as "Service Provider") as a Free service.
        This service is intended for use "AS IS".
      </p>
      <br />
      <strong>How the Application Works</strong>
      <p>
        BlindDuel is a two-player local party game. Two phones connect
        directly to each other over Bluetooth/Wi-Fi Direct using Google
        Nearby Connections — there is no game server, and no gameplay data is
        ever sent to the Service Provider or stored on any remote server. All
        information described below is either kept entirely on your device or
        transmitted directly, peer-to-peer, to the other player's device for
        the duration of a single game session only. If the peer-to-peer
        connection between the two devices briefly drops during a match, the
        Application will automatically attempt to reconnect for a short
        window before ending the session; this does not change what
        information is collected or how it is used.
      </p>
      <br />
      <strong>Information Collection and Use</strong>
      <p>
        The Application collects and uses the following information, all of
        which stays local to your device or is sent only to the other
        player's device during an active session:
      </p>
      <ul>
        <li>
          <strong>Display name</strong> — the name you enter before hosting or
          joining a game is sent to the other player's device so it can be
          shown on their screen. It is not stored beyond the current session.
        </li>
        <li>
          <strong>Compass heading and step-detector data</strong> — used to
          estimate your phone's orientation and movement so the game can
          approximate the other player's rough direction. This data is
          exchanged directly between the two connected devices roughly ten
          times per second while a match is active and is discarded when the
          match ends.
        </li>
        <li>
          <strong>QR code / session code</strong> — a randomly generated code
          used only to pair two devices for a single session. It is not
          linked to any personal identity.
        </li>
        <li>
          <strong>Match event data</strong> — hits, health changes, dodges,
          and weapon pickups are exchanged directly between the two connected
          devices as they happen during a match, the same way compass/step
          data is. If you choose to watch the optional post-match replay, this
          same event data is held briefly in your device's memory (never
          written to disk) so the replay can be played back; it is cleared
          automatically when you leave the replay screen, start another
          match, or close the app.
        </li>
      </ul>
      <p>
        No account creation, login, or persistent player profile exists in
        the Application. No gameplay data survives after you close the app.
      </p>
      <br />
      <strong>Permissions</strong>
      <p>
        The Application requests the following device permissions and uses
        them as described:
      </p>
      <ul>
        <li>
          <strong>Camera</strong> — used only to scan the QR code displayed by
          the other player's device in order to connect. No photos or video
          are captured, stored, or transmitted.
        </li>
        <li>
          <strong>Nearby devices / Bluetooth (BLUETOOTH_ADVERTISE,
          BLUETOOTH_CONNECT, BLUETOOTH_SCAN, NEARBY_WIFI_DEVICES) and, on
          older Android versions, precise location (ACCESS_FINE_LOCATION)
          </strong>{" "}
          — required by the Android Nearby Connections API to discover and
          connect to the other player's device. On Android 12 and above, the
          Application uses the scoped Bluetooth permissions and does not
          request location; on older Android versions, Android requires
          location permission to be granted for Bluetooth/Wi-Fi peer
          discovery to function, even though the Application does not read or
          use your GPS location. No location coordinates are ever collected,
          stored, or transmitted by the Application.
        </li>
        <li>
          <strong>Physical activity (ACTIVITY_RECOGNITION)</strong> — used to
          read step-detector sensor events so the game can estimate your
          movement during a match. This permission is optional; if denied,
          the Application falls back to a heading-only estimate and remains
          fully playable.
        </li>
        <li>
          <strong>Vibration</strong> — used to provide haptic feedback when
          you are hit during a match. No data is collected.
        </li>
        <li>
          <strong>Internet / Wi-Fi state</strong> — required by the Nearby
          Connections API to establish the local peer-to-peer link between
          the two devices. The Application does not use the internet to
          communicate with any server operated by the Service Provider.
        </li>
      </ul>
      <p>
        You may revoke any of these permissions at any time through your
        device's system settings. Revoking a permission may disable the
        corresponding feature, as described above.
      </p>
      <br />
      <strong>Third Party Access</strong>
      <p>
        The Application uses Google Play Services (Nearby Connections API and
        ML Kit barcode scanning, both of which run entirely on-device) to
        connect the two players' devices and to scan the QR pairing code.
        These components do not transmit gameplay data to Google or any other
        third party. See{" "}
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google's Privacy Policy
        </a>{" "}
        for details on how Google Play Services operates.
      </p>
      <p>
        The Application contains no analytics, advertising, or crash-reporting
        SDKs, and does not share information with any other third party.
      </p>
      <br />
      <strong>Data Retention Policy</strong>
      <p>
        The Application does not write any gameplay data to persistent
        storage. The optional post-match replay is held only in memory for as
        long as you remain on the replay screen, and is cleared as soon as you
        start another match or close the app. There is nothing to delete,
        export, or reset, because nothing survives beyond the lifetime of the
        app process.
      </p>
      <br />
      <strong>Children</strong>
      <p>
        The Service Provider does not use the Application to knowingly
        solicit data from or market to children under the age of 13. The
        Service Provider does not knowingly collect personally identifiable
        information from children. Parents and guardians are encouraged to
        monitor their children's use of the Application. If you believe a
        child has provided personally identifiable information through the
        Application, please contact the Service Provider at
        eataburrita@gmail.com. You must be at least 16 years of age to
        consent to the processing of your personally identifiable information
        (in some countries a parent or guardian may consent on your behalf).
      </p>
      <br />
      <strong>Security</strong>
      <p>
        Because the Application does not transmit gameplay data to any server,
        the security of your information depends primarily on the security of
        your device and of the direct connection between the two paired
        devices. The Service Provider recommends using device-level security
        features such as screen locks and keeping your operating system
        updated.
      </p>
      <br />
      <strong>Changes</strong>
      <p>
        This Privacy Policy may be updated from time to time for any reason.
        The Service Provider will notify you of any changes to the Privacy
        Policy by updating this page with the new Privacy Policy. You are
        advised to consult this Privacy Policy regularly for any changes, as
        continued use is deemed approval of all changes.
      </p>
      <br />
      <p>This privacy policy is effective as of 2026-08-19</p>
      <br />
      <strong>Your Consent</strong>
      <p>
        By using the Application, you are consenting to the processing of
        your information as set forth in this Privacy Policy now and as
        amended by us.
      </p>
      <br />
      <strong>Contact Us</strong>
      <p>
        If you have any questions regarding privacy while using the
        Application, or have questions about the practices, please contact
        the Service Provider via email at eataburrita@gmail.com.
      </p>
    </BoringContainer>
  );
}
